import { useAuth } from "react-oidc-context";
import { authUtils } from "./authUtils";

interface ProtectedRouteProps {
  requiredRole?: string;
  children: any;
}

function ProtectedRoute({ requiredRole, children }: ProtectedRouteProps) {
  const auth = useAuth();

  if (authUtils.hasRole(auth, requiredRole ?? authUtils.User)) {
    return children;
  }

  return <div>Forbidden</div>;
}

export default ProtectedRoute;
